
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"#DEDEDE","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.5","cy":"9.145","r":"7.75","stroke-width":".1","stroke":"#fff"}}),_c('circle',{attrs:{"cx":"8.5","cy":"9.145","r":"6.25","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.867 7.73a.628.628 0 011.255 0v5.885a.628.628 0 01-1.255 0V7.73zm.628-2.003a.845.845 0 01-.615-.242.82.82 0 01-.235-.593.82.82 0 01.235-.593.822.822 0 01.615-.256c.244 0 .444.08.601.243a.754.754 0 01.249.579c0 .242-.083.449-.249.62a.802.802 0 01-.601.242z","stroke-width":".1","stroke":"#fff"}})])
          )
        }
      }
    